export const API_KEY = "f175e530c38760bab52d4d1626db82c6";
export const API_HOST = process.env.REACT_APP_API_HOST;
export const LANG = process.env.REACT_APP_LANG;
export const BASE_URL_BANNER =
  "https://image.tmdb.org/t/p/w1920_and_h427_multi_faces/";
